import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';
import { AuthorProps } from 'libs/contentful/props';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { formatDate } from 'utils/formatters';

type BlogAuthorProps = AuthorProps & {
  blogDate?: string;
};

const BaseWithBlogAuthor = ({ name, image, url, blogDate, internalPage, sys }: BlogAuthorProps) => {
  const hasLink = url || internalPage;
  const formattedDate = blogDate ? formatDate(blogDate) : null;

  return (
    <div className="flex items-center gap-2">
      {image && <Media media={image} sizes={'40px'} className={'size-[40px] rounded-full object-cover'} />}
      <p className="font-serif text-lg" {...liveUpdateAttrs(sys?.id, 'name')}>
        {hasLink ? (
          <Link className="underline hover:no-underline" href={url} internalPage={internalPage}>
            {name}
          </Link>
        ) : (
          name
        )}
      </p>
      {blogDate && (
        <p data-testid="blog-date" className="font-serif text-lg">
          <span className="pr-1">•</span> {formattedDate}
        </p>
      )}
    </div>
  );
};

export default BaseWithBlogAuthor;
